import React, { useMemo, useRef, useState } from "react";
import { Biohazard, Radiation, Dna, FlaskConical, Syringe, Bug, Lock } from "lucide-react";
import { shuffle } from "../../data/sporeGames";

const ICONS = [Biohazard, Radiation, Dna, FlaskConical, Syringe, Bug];

export const MemoryGame = ({ onWin }) => {
  const deck = useMemo(() => shuffle([...ICONS.keys(), ...ICONS.keys()]), []);
  const [flipped, setFlipped] = useState([]);
  const [matched, setMatched] = useState([]);
  const lock = useRef(false);

  const flip = (i) => {
    if (lock.current || flipped.includes(i) || matched.includes(i)) return;
    const next = [...flipped, i];
    setFlipped(next);
    if (next.length < 2) return;
    const [a, b] = next;
    if (deck[a] === deck[b]) {
      const all = [...matched, a, b];
      setMatched(all);
      setFlipped([]);
      if (all.length === deck.length) onWin();
      return;
    }
    lock.current = true;
    setTimeout(() => {
      setFlipped([]);
      lock.current = false;
    }, 650);
  };

  return (
    <div className="space-y-5" data-testid="memory-game">
      <div className="flex items-center justify-between font-tac text-sm">
        <span className="text-slate-400">PAIRS MATCHED</span>
        <span data-testid="memory-pair-count" className="text-amber-300 tabular-nums text-lg">{matched.length / 2} / {ICONS.length}</span>
      </div>
      <div className="grid grid-cols-4 gap-2 sm:gap-3 max-w-lg mx-auto">
        {deck.map((iconIdx, i) => {
          const Icon = ICONS[iconIdx];
          const open = flipped.includes(i) || matched.includes(i);
          const done = matched.includes(i);
          return (
            <button
              key={i}
              type="button"
              data-testid={`memory-card-${i}`}
              data-icon={iconIdx}
              onClick={() => flip(i)}
              className={`aspect-[3/4] rounded-sm border flex items-center justify-center transition-[background-color,border-color,transform] duration-300 ${
                done
                  ? "border-emerald-500/60 bg-emerald-950/40"
                  : open
                  ? "border-amber-400 bg-amber-950/40 scale-[1.03]"
                  : "border-slate-700 bg-slate-900 hover:border-amber-500/60 spore-grid-bg"
              }`}
            >
              {open ? (
                <Icon className={`h-1/2 w-1/2 spore-pop ${done ? "text-emerald-300" : "text-amber-300"}`} />
              ) : (
                <Lock className="h-5 w-5 text-slate-600" />
              )}
            </button>
          );
        })}
      </div>
    </div>
  );
};
